export default "__VITE_ASSET__0b46782b__"